import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import Arrow from 'svgs/icons/arrow-point-to-right.svg';
import { link, root, seperator } from './Breadcrumb.module.scss';

const Breadcrumb = ({ links }) => (
  <ul className={root}>
    {links.map((item, i) => (
      <li key={i}>
        <Link to={item.link} className={link}>
          {item.text}
        </Link>
        <span className={seperator}>
          <Arrow />
        </span>
      </li>
    ))}
  </ul>
);

Breadcrumb.propTypes = {
  links: PropTypes.array.isRequired,
};

export default Breadcrumb;
